module.exports = __webpack_public_path__ + "static/media/cauldron.d700c8ef.svg";